import type { ReactNode } from 'react'

import { cn } from '@/lib/utils/cn'

export type AlertTone = 'info' | 'warning' | 'danger'

const TONE_CLASS: Record<AlertTone, string> = {
  info: 'border-brand-100 bg-brand-50 text-ink-700',
  warning: 'border-warning-500/30 bg-warning-100 text-ink-700',
  danger: 'border-danger-500/30 bg-danger-100 text-ink-700',
}

export function Alert({
  tone = 'info',
  title,
  children,
  action,
  className,
}: {
  tone?: AlertTone
  title?: ReactNode
  children?: ReactNode
  action?: ReactNode
  className?: string
}) {
  return (
    <div
      role={tone === 'info' ? 'note' : 'alert'}
      className={cn(
        'flex flex-col gap-3 rounded-xl border px-5 py-4 sm:flex-row sm:items-center sm:justify-between',
        TONE_CLASS[tone],
        className
      )}
    >
      <div className="space-y-1">
        {title ? <p className="text-sm font-semibold">{title}</p> : null}
        {children ? <div className="text-sm text-slateish-600">{children}</div> : null}
      </div>
      {action}
    </div>
  )
}
